import {ApiError} from "@app/core/shared/domain/api.error";

/**
 * Error types that occur at the infrastructure level.
 * These errors typically reflect issues with connectivity, server unresponsiveness, or request timeouts.
 */
export enum InfrastructureErrorType {
    ConnectionError,
    InternalServerError,
    TimeOutError,
    BackendError,
    ServiceUnavailableError,
}

/**
 * Error that occur at the infrastructure level, such as connection issues or backend failures.
 */
export class InfrastructureError implements Error {

    name: string;
    message: string;
    stack: string | undefined;

    constructor(public _type: InfrastructureErrorType, public _error: any | null, message?: string, public apiError?: ApiError) {
        this.name = ""
        this.message = message ?? ""
    }


    get type(): InfrastructureErrorType {
        return this._type;
    }

    get error(): any {
        return this._error;
    }
}
